import Vuex from 'vuex'
import Vue from 'vue'
//import tekenaars from './modules/tekenaars'
import db from '../firebase/firebaseInit'
import betalog from './modules/betalog'

import user from './modules/user'
import emailpopup from './modules/emailpopup'
import uploadFile from './modules/uploadFile'
import blogs from './modules/blogs'

import firebase from 'firebase'

const functions = firebase.functions()
//import functions from 'firebase-functions';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    betalog,
    user,
    emailpopup,
    uploadFile,
    blogs
  },

  state: {
    userAccounts: [],
    showNewProfileModal: false,
    selectedUserProfileId: null,
    statussen: [
      'Nieuw',
      'Toegewezen',
      'Uitgezet',
      'Geaccepteerd',
      'Gestart',
      'Beëindigd'
    ],
    disciplines: [
      'Bouwkunde',
      'Werktuigbouwkunde',
      'Installatietechniek',
      'Elektrotechniek',
      'Brandpreventie',
      'Huisvesting',
      'Plattegronden',
      'Concepten - 3D Print',
      'Nen2580',
      'Sem'
    ],
    disciplines_lowercase: [
      'bouwkunde',
      'werktuigbouwkunde',
      'installatietechniek',
      'elektrotechniek',
      'brandpreventie',
      'huisvesting',
      'plattegronden',
      'concepten -3d print',
      'nen2580',
      'sem'
    ],

    status: {},

    tekenaars: [],
    opdrachten: [],

    opdrachtid: 'yHKq2fUVNZYLYX5HUQ2b',

    showTekFilters: false,
    showNewProfiles: false,
    tekFilters: {
      name: '',
      email: '',
      telefoonnummer: '',
      disciplines: '',
      bedrijfsnaam: '',
      woonplaats: '',
      tekenprogramma: ''
    },

    showOpdrFilters: false,
    opdrFilters: {
      opdrachtnummer: '',
      status: '',
      telefoonnummer: '',
      disciplines: '',
      bedrijfsnaam: ''
    },
    showOpdrOnHold: false,
    showOpdrGeannuleerd: false,
    showOpdrBeëindigd: false
  },

  mutations: {
    set_userAccounts(state, payload) {
      state.userAccounts = payload
    },
    setStatus (state, payload) {
      state.status = payload
      console.log(payload)
    },
    setSelectedUserProfileId: (state, e) => state.selectedUserProfileId = e,
    setShowNewProfileModal: (state) => state.showNewProfileModal = !state.showNewProfileModal,
    setShowNewProfiles: (state, e) => state.showNewProfiles = e,
    // setStatus: (state, status) => (state.status = status),
    setTekenaars: (state, tekenaars) => (state.tekenaars = tekenaars),
    setOpdrachten: (state, opdrachten) => (state.opdrachten = opdrachten),

    updateTekFilters (state, payload) {
      state.tekFilters = payload
    },

    toggleShowTekFilters (state, payload) {
      if (state.showTekFilters == payload) {
        state.showTekFilters = !payload
      }
    },

    updateOpdrFilters (state, payload) {
      state.opdrFilters = payload
    },
    toggleShowOpdrFilters (state, payload) {
      if (state.showOpdrFilters == payload) {
        state.showOpdrFilters = !payload
      }
    },
    toggleShowOpdrOnHold (state, payload) {
      if (state.showOpdrOnHold == payload) {
        state.showOpdrOnHold = !payload
      }
    },
    toggleShowOpdrGeannuleerd (state, payload) {
      if (state.showOpdrGeannuleerd == payload) {
        state.showOpdrGeannuleerd = !payload
      }
    },
    toggleShowOpdrBeëindigd (state, payload) {
      console.log('fuck')

      if (state.showOpdrBeëindigd == payload) {
        state.showOpdrBeëindigd = !payload
      }
    }
  },

  getters: {
    allTekenaars: state => state.tekenaars,
    allOpdrachten: state => state.opdrachten,
    allDisciplines: state => state.disciplines
  },

  actions: {
    //Email akkoordmail naar tek bij nieuwe opdr
    async testZapierWebhook () {
      const callable = functions.httpsCallable('deleteTekenaar')
      return callable()
        .then(() =>
          // do something here
          alert('webhook functie getriggerd')
        )
        .catch(err => console.log(err))
    },

    // async sendEmail(e) {
    //   const callable = functions.httpsCallable('genericEmail');
    //   return callable({
    //     //msg: e
    //     // emailList: app.emaillistholder,
    //     // opdrachtnummer: 'CDT.2020.' + e.opdrachtnummer,
    //     // discipline: e.disciplines,
    //     // tekenprogramma: e.tekenprogramma,
    //     // intakeveld: e.intake,
    //   }).then(
    //     alert("Email succesvol verzonden!")
    //   )
    // },

    async fetchStatus ({ commit }) {
      db.collection('status')
        .doc('status')
        .onSnapshot(function (doc) {
          commit('setStatus', doc.data())
        })
    },

    async setMessengerStatusFalse () {
      try {
        db.collection('status')
          .doc('status')
          .set({
            messenger: false
          })
      } catch (error) {
        console.error('Error writing document: ', error)
        alert(
          'Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur'
        )
      }
    },

    // async fetchStatus({}) {
    //   let status = [];
    //   db.collection('status')
    //     .doc('status')
    //     .onSnapshot(res => {
    //       const changes = res.docChanges();
    //       changes.forEach(change => {
    //         // const { newIndex, oldIndex, doc, type } = change

    //         const { newIndex, oldIndex } = change;
    //         if (change.type === 'added') {
    //           const data = {
    //             ...change.doc.data()
    //           };
    //           status.push(data);
    //         } else if (change.type === 'modified') {
    //           status.splice(oldIndex, 1);
    //           var newdata = {
    //             ...change.doc.data()
    //           };
    //           status.push(data);
    //           status.splice(newIndex, 0, newdata);
    //         } else if (change.type === 'removed') {
    //           status.push(data);
    //           status.splice(oldIndex, 1);
    //           //app.opdrachten.splice(oldIndex, 1)
    //         }
    //         this.commit('setOpdrachten', status);
    //       });
    //     });
    // },

    async fetchTekenaren ({ commit }) {
      let list = []
      db.collection('tekenaars')
        .where('kvkingeschreven', '==', 'Ja')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //const data = doc.data()
            const data = {
              id: doc.id || '',
              voornaam: doc.data().voornaam || '',
              achternaam: doc.data().achternaam || '',
              naam: doc.data().voornaam + ' ' + doc.data().achternaam || '',
              disciplines: doc.data().disciplines || ['geen disciplines...'],
              aantekening: doc.data().aantekening || '',
              email: doc.data().email || '',
              telefoonnummer: doc.data().telefoonnummer || '',
              tekenprogramma: doc.data().tekenprogramma || '',
              woonplaats: doc.data().woonplaats || '',
              bedrijfsnaam: doc.data().bedrijfsnaam || '',
              website: doc.data().website || '',
              opleiding: doc.data().opleiding || '',
              kvknummer: doc.data().kvknummer || '',
              rating: doc.data().rating || 0,
              werkgebied: doc.data().werkgebied || '',
              adres: doc.data().adres || '',
              log: doc.data().log || ''
            }
            console.log(data)
            list.push(data)
          })
        })
      commit('setTekenaars', list)
    },


    async getUserAccountsOfTekenaars({commit}) {
      db.collection(`users`).onSnapshot(resultArray => {
        let newArray = []
        resultArray.forEach(user => {
          console.log('DAMN');
          const userBlock = {
            ...user.data(),
            id: user.id
          }
          newArray.push(userBlock)
        })
        commit('set_userAccounts', newArray)
      })
    },

    async fetchOpdrachten ({dispatch}) {
      dispatch('getUserAccountsOfTekenaars')
      function transformTelefoonnummer (nummer) {
        if (typeof nummer === 'string') {
          // return nummer.replace('"', '');
          console.log(nummer)

          return nummer.replace(/"/g, '')
        } else {
          return nummer
        }
      }

      let list = []
      db.collection('opdrachten')
        .where('bedrijfsnaam', '>', '')
        .onSnapshot(res => {
          const changes = res.docChanges()
          changes.forEach(change => {
            // const { newIndex, oldIndex, doc, type } = change

            const { newIndex, oldIndex } = change
            if (change.type === 'added') {
              const data = {
                id: change.doc.id,
                intake:
                  change.doc.data().intake ||
                  'Tekenprogramma:\nDiscipline:\nWerkplek\nType Opdracht:\nOmschrijving:\n',
                onhold: change.doc.data().onhold || false,
                ...change.doc.data(),
                telefoonnummer:
                  transformTelefoonnummer(change.doc.data().telefoonnummer) ||
                  ''
              }
              list.push(data)
            } else if (change.type === 'modified') {
              list.splice(oldIndex, 1)
              var newdata = {
                id: change.doc.id,
                onhold: change.doc.data().onhold || false,
                ...change.doc.data()
              }
              list.splice(newIndex, 0, newdata)
            } else if (change.type === 'removed') {
              list.splice(oldIndex, 1)
              //app.opdrachten.splice(oldIndex, 1)
            }
            this.commit('setOpdrachten', list)
          })
        })
    },

    async addTekToDB (context, payload) {
      try {
        db.collection('tekenaars')
          .add({
            voornaam: payload.voornaam || '',
            adres: payload.adres || '',
            woonplaats: payload.woonplaats || '',
            achternaam: payload.achternaam || '',
            kvknummer: payload.kvknummer || '',
            opleiding: payload.opleiding || '',
            email: payload.email || '',
            werkgebied: payload.werkgebied || '',
            tekenprogramma: payload.tekenprogramma || '',
            telefoonnummer: payload.telefoonnummer || '',
            bedrijfsnaam: payload.bedrijfsnaam || '',
            disciplines: payload.disciplines || [],
            aantekening: payload.aantekening || '',
            kvkingeschreven: 'Ja'
          })
          .then(function () {
            console.log('Tekenaar Opgeslagen in DB')
            alert(
              'Toevoegen nieuwe tekenaar is gelukt! LET OP: reload de pagina :)'
            )
          })
      } catch (error) {
        console.error('Error writing document: ', error)
        alert(
          'Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur'
        )
      }
    },

    async addOpdrToDB (context, payload) {
      try {
        db.collection('opdrachten')
          .add({
            ...payload,
            status: 'Nieuw'
          })
          .then(function () {
            console.log('Opdracht Opgeslagen in DB')
            alert('Toevoegen nieuwe opdracht is gelukt!')
          })
      } catch (error) {
        console.error('Error writing document: ', error)
        alert(
          'Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur'
        )
      }
    },

    async duplicateOpdrToDB (context, payload) {
      try {
        db.collection('opdrachten').add({
          ...payload,
          status: 'Nieuw'
        })
      } catch (error) {
        console.error('Error writing document: ', error)
        alert(
          'Opslaan van kopie opdracht is niet gelukt, probeer het opnieuw of neem contact op met Christiaan'
        )
      }
    },

    //Email akkoordmail naar tek bij nieuwe opdr
    async sendEmail (context, payload) {
      const callable = functions.httpsCallable('zetOpdrachtUitNaarTekenaar')
      return callable(payload)
        .then(() =>
          // do something here
          alert('email succesvol verstuurd naar tek')
        )
        .catch(err => console.log(err))
    },

    //Email market naar alle tekenaars binnen discipline
    async sendMarketingEmail (context, payload) {
      const callable = functions.httpsCallable('marketingEmail')
      return callable({
        emailList: payload.emaillistholder,
        opdrachtnummer: 'CDT.2020.' + payload.opdrachtnummer,
        discipline: payload.discipline,
        tekenprogramma: payload.tekenprogramma,
        intakeveld: payload.intakeveld
      })
        .then(() =>
          // do something here
          alert('email succesvol verstuurd naar tek')
        )
        .catch(err => console.log(err))
    },
    //Email market TESTTEST naar alle tekenaars binnen discipline
    async sendMarketingEmailTEST (context, payload) {
      const callable = functions.httpsCallable('marketingEmail')
      return callable({
        // emailList: payload.emaillistholder,
        opdrachtnummer: 'CDT.2020.' + payload.opdrachtnummer,
        discipline: payload.discipline,
        tekenprogramma: payload.tekenprogramma,
        intakeveld: payload.intakeveld
      })
        .then(() =>
          // do something here
          alert('test email succesvol verstuurd')
        )
        .catch(err => console.log(err))
    },

    // DB Write Functions

    // DELETE tekenaar
    async deleteTekenaar (context, payload) {
      db.collection('tekenaars')
        .doc(payload)
        .delete()
        .then(function () {
          console.log('Tekenaar is verwijderd')
          alert('Tekenaar is verwijderd')
        })
        .catch(function (error) {
          console.error('Error bij verwijderen van tekenaar: ', error)
        })
    },

    // OnHold opdracht
    async onholdOpdracht (context, payload) {
      db.collection('opdrachten')
        .doc(payload)
        .update({
          onhold: true
        })
        .then(function () {
          console.log('opdracht is on hold gezet')
        })
        .catch(function (error) {
          console.error(
            'Error bij onhold zetten van opdracht in firestore: ',
            error
          )
        })
    },

    // ANNULEER opdracht
    async annuleerOpdracht (context, payload) {
      db.collection('opdrachten')
        .doc(payload)
        .update({
          geannuleerd: true
        })
        .then(function () {
          console.log('opdracht is geannuleerd')
        })
        .catch(function (error) {
          console.error(
            'Error bij annulering van opdracht in firestore: ',
            error
          )
        })
    },

    async zetOpdrachtOnHold (context, payload) {
      db.collection('opdrachten')
        .doc(payload)
        .update({
          onhold: true
        })
        .then(function () {
          console.log('opdracht is nu on hold')
        })
        .catch(function (error) {
          console.error(
            'Error bij onhold zetten van opdracht in firestore: ',
            error
          )
        })
    },

    async zetOpdrachtTerug (context, payload) {
      db.collection('opdrachten')
        .doc(payload)
        .update({
          geannuleerd: false
        })
        .then(function () {
          console.log('opdracht is teruggezet')
        })
        .catch(function (error) {
          console.error(
            'Error bij terugzetten van opdracht in firestore: ',
            error
          )
        })
    },

    async maakOpdrachtWeerActief (context, payload) {
      db.collection('opdrachten')
        .doc(payload)
        .update({
          onhold: false
        })
        .then(function () {
          console.log('opdracht is weer actief')
        })
        .catch(function (error) {
          console.error(
            'Error bij activeren van opdracht in firestore: ',
            error
          )
        })
    },

    // voeg logentry toe aan log van opdracht toe
    async updateOpdrLog (context, payloadLog) {
      db.collection('opdrachten')
        .doc(payloadLog.id)
        .update({
          log: firebase.firestore.FieldValue.arrayUnion(payloadLog.log)
        })
        .then(function () {
          console.log('Log is geupdatet')
        })
        .catch(function (error) {
          console.error('Error writing log for document: ', error)
        })
    },

    // voeg logentry toe aan log van opdracht toe
    async updateTekLog (context, payloadLog) {
      db.collection('tekenaars')
        .doc(payloadLog.id)
        .update({
          log: firebase.firestore.FieldValue.arrayUnion(payloadLog.log)
        })
        .then(function () {
          console.log('Log is geupdatet')
        })
        .catch(function (error) {
          console.error('Error writing log for document: ', error)
        })
    },

    async updateOpdrStatus (context, payload) {
      try {
        db.collection('opdrachten')
          .doc(payload.opdrachtid)
          .update({
            status: payload.status
          })
          .then(function () {
            console.log('Opdr geupdate')
          })
      } catch (error) {
        console.error('Error writing document: ', error)
        alert(
          'Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur'
        )
      }
    },

    async saveOpdrChanges (context, payload) {
      // DEZE FUNCTIE TRIGGERDE WEL MAAR KON GEEN ERRORS OPVANGEN VANWEGE DE ASYNC
      // db.collection("opdrachten").doc(payload.id).update({
      //   email: payload.email,
      //   telefoonnummer: payload.telefoonnummer || "",
      //   intake: payload.intake || "",
      //   disciplines: payload.disciplines || "",
      //   omschrijving: payload.omschrijving || "",
      //   bedrijfsnaam: payload.bedrijfsnaam || "",
      //   gemarket: payload.gemarket ,
      // }).then(function() {
      //   console.log("Opdr geupdate");
      //   alert("Wijzigingen succesvol opgeslagen")
      // }).catch(function(error) {
      //   console.error("Error writing document: ", error);
      //   alert("Er is iets fout gegaan bij het opslaan")
      // });

      // OPLOSSING: TRY -> CATCH BLOK
      try {
        db.collection('opdrachten')
          .doc(payload.id)
          .update({
            email: payload.email,
            telefoonnummer: payload.telefoonnummer || '',
            intake: payload.intake || '',
            disciplines: payload.disciplines || '',
            omschrijving: payload.omschrijving || '',
            bedrijfsnaam: payload.bedrijfsnaam || '',
            gemarket: payload.gemarket || 'Nee',
            tekenprogramma: payload.tekenprogramma || '',
            werkplek: payload.werkplek || '',
            typeopdracht: payload.typeopdracht || '',
            voornaam: payload.voornaam || '',
            achternaam: payload.achternaam || ''
          })
          .then(function () {
            console.log('Opdr geupdate')
            alert('Wijzigingen succesvol opgeslagen')
          })
      } catch (error) {
        alert(
          'Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur'
        )
        if (
          typeof error.response !== 'undefined' &&
          typeof error.response.data !== 'undefined' &&
          error.response.data !== null
        ) {
          throw new Error(error.response.data)
        } else {
          throw error
        }
      }
    },

    async saveTekChanges (context, payload) {
      db.collection('tekenaars')
        .doc(payload.id)
        .update({
          email: payload.email,
          // disciplines: payload.disciplines,
          telefoonnummer: payload.telefoonnummer,
          aantekening: payload.aantekening,
          bedrijfsnaam: payload.bedrijfsnaam,
          woonplaats: payload.woonplaats,
          kvknummer: payload.kvknummer,
          werkgebied: payload.werkgebied,
          rating: payload.rating,
          adres: payload.adres,
          tekenprogramma: payload.tekenprogramma,
          opleiding: payload.opleiding,
          disciplines: payload.disciplines,
          voornaam: payload.voornaam,
          achternaam: payload.achternaam
        })
        .then(function () {
          console.log('Tek geupdate')
          alert('Wijzigingen succesvol opgeslagen')
        })
        .catch(function (error) {
          console.error('Error writing document: ', error)
          alert('Er is iets fout gegaan bij het opslaan')
        })
    },

    async koppelTekAanOpdr (context, payload) {
      db.collection('opdrachten')
        .doc(payload.opdrachtid)
        .update({
          tekenaarsid: payload.tekenaarsid
        })
        .then(function () {
          console.log('Opdr geupdate')
        })
        .catch(function (error) {
          console.error('Error writing document: ', error)
        })
    },

    async ontkoppelTekVanOpdr (context, payload) {
      db.collection('opdrachten')
        .doc(payload.opdrachtid)
        .update({
          tekenaarsid: ''
        })
        .then(function () {
          console.log('Opdr geupdate')
        })
        .catch(function (error) {
          console.error('Error writing document: ', error)
        })
    }
  }
})
